import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import { BORDER, COLOR_GREY_4 } from "shared/theme/colors";
import { flex } from "shared/theme/mixins";

export const StyledTicketChatHeaderContainer = styled(Box)`
  ${flex({ fd: "column" })};
  row-gap: 1rem;
  padding: 1.5rem 1.5rem 1rem;
  border-bottom: ${BORDER(1, COLOR_GREY_4)};
`;

export const StyledCategoryContainer = styled(Box)`
  ${flex({ ai: "center", jc: "space-between" })};
  width: 100%;
`;
